export const approximate = (number = 0, fractionDigits = 2) => {
  return parseFloat(Number(number).toFixed(fractionDigits))
}
